import { filterByUsers } from '@/Helpers/ProgrammationHelper'

export const filterTasksForCurrentUser = (
  items: any[],
  onlyShowMine: boolean,
  userId?: string,
) => {

  if (!onlyShowMine || !userId) return items

  return filterByUsers(items, [userId])
}
